var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"b-consult-card-arrow"},[_c('div',{staticClass:"b-consult-card-arrow__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"b-consult-card-arrow__icon"},[_c('FwIcon',{staticClass:"h-mh-5",attrs:{"icon":"arrow-right","size":"20","color":"#27dbbd"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }